import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import SelectDropdown from "../../components-react/SelectDropdown";
import { accountTypes } from "../../common-data/DropdowData";
import { fetchIndividualTypeData } from "../../../redux/reducers/dropdownApiSlice";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  addApprovalManager,
  updateApprovalManager,
} from "../../../data/ApiEndpoints";
import MultiSelect from "../../components-react/MultiSelect";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const AMForm = ({
  userInfoData,
  closeModal,
  callFunction,
  rowData,
  isEdit,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { individualData } = useSelector((state) => state.dropdown);
  const { loading } = useSelector((state) => state.common);

  const iniFormValues = [
    {
      selectedGym:
        isEdit && rowData?.approval_centers?.length > 0
          ? rowData.approval_centers?.map((center) => ({
              value: center.gym_id,
              label: center.gym_name,
            }))
          : [],
      selectedUser:
        isEdit && rowData?.user_id && rowData?.user_name
          ? {
              label: rowData.user_name,
              value: rowData.user_id,
            }
          : "",
      selectedFor:
        isEdit && rowData?.for_ac_type
          ? {
              label:
                rowData.for_ac_type === "receptionist"
                  ? "Sales Executive"
                  : rowData.for_ac_type?.replace(/_/g, " "),
              value: rowData.for_ac_type,
            }
          : "",
    },
  ];
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  // const onChangeDropdown = (name, value) => {
  //   setFormValues((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  const onChangeDropdown = (name, value) => {
    let updatedFormValues = { ...formValues, [name]: value };

    if (name === "selectedUser") {
      const accountType = value?.info?.account_type;

      if (accountType === "admin") {
        updatedFormValues = {
          ...updatedFormValues,
          selectedGym: gymData,
        };
      } else if (accountType === "cluster_manager") {
        const matchedGyms =
          userInfoData?.gyms?.gyms?.filter((gym) =>
            gymData.some((data) => data.value === gym.value)
          ) || [];

        updatedFormValues = {
          ...updatedFormValues,
          selectedGym: matchedGyms,
        };
      } else {
        updatedFormValues = {
          ...updatedFormValues,
          selectedGym: [],
        };
      }
    }

    setFormValues(updatedFormValues);
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    if (!formValues.selectedUser) {
      errors.selectedUser = "required!";
    }

    if (!formValues.selectedFor) {
      errors.selectedFor = "required!";
    }

    if (formValues.selectedGym?.length === 0) {
      errors.selectedGym = "required!";
    }

    return errors;
  };

  function getAllAdmins() {
    dispatch(
      fetchIndividualTypeData({
        token: userInfoData?.token,
        // qps: `account_type=admin`,
        qps: `account_type=admin,cluster_manager`,
        pageNo: 1,
        limit: 100,
      })
    );
  }

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? updateApprovalManager : addApprovalManager;
    const payload = requestBody;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getAllAdmins();
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (isEdit && rowData) {
      const preSelectedGyms =
        rowData?.approval_centers?.length > 0
          ? rowData.approval_centers.map((center) => ({
              value: center.gym_id,
              label: center.gym_name,
            }))
          : [];

      console.log(preSelectedGyms, " <=rowData?.approval_centers=> ");

      setFormValues((prevs) => ({
        ...prevs,
        selectedGym: preSelectedGyms,
        selectedUser:
          rowData?.user_id && rowData?.user_name
            ? {
                label: rowData.user_name,
                value: rowData.user_id,
              }
            : "",
        selectedFor: rowData?.for_ac_type
          ? {
              label:
                rowData.for_ac_type === "receptionist"
                  ? "Sales Executive"
                  : rowData.for_ac_type?.replace(/_/g, " "),
              value: rowData.for_ac_type,
            }
          : "",
      }));
    }
  }, []);

  // useEffect(() => {
  //   const { selectedUser } = formValues;
  //   const accountType = selectedUser?.info?.account_type;

  //   if (accountType === "admin") {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       selectedGym: gymData,
  //     }));
  //   } else if (accountType === "cluster_manager") {
  //     const matchedGyms =
  //       userInfoData?.gyms?.gyms?.filter((gym) =>
  //         gymData.some((data) => data.value === gym.value)
  //       ) || [];

  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       selectedGym: matchedGyms,
  //     }));
  //   } else {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       selectedGym: [],
  //     }));
  //   }
  // }, [formValues.selectedUser]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const gymIds = formValues.selectedGym.map((gym) => gym?.value);

      const userData = {
        user_id: formValues.selectedUser?.value,
        for_ac_type: formValues.selectedFor?.value,
        approval_centers: gymIds,
      };

      if (isEdit) {
        userData.uid = rowData.uid;
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedUser" className="formInputLabel">
              Choose Approval Manager <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedUser ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={
                  individualData && individualData?.length > 0
                    ? individualData
                    : []
                }
                selectedOption={formValues.selectedUser}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedUser", selectedValue)
                }
                name="Leave Type"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedFor" className="formInputLabel">
              Staff Category <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedFor ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={accountTypes}
                selectedOption={formValues.selectedFor}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedFor", selectedValue)
                }
                name="Approval Manager For"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedGym" className="formInputLabel">
              gym <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper no-border multi-select ${
                formErrors.selectedGym ? "error" : ""
              }`}
            >
              <MultiSelect
                options={gymData?.length > 0 ? gymData : []}
                state={formValues.selectedGym}
                setState={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedGym: selectedValue,
                  }))
                }
                name="select multiple from the list"
              />
            </div>
          </div>
        </div>

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
            {loading ? <ReactVortoxSpinner /> : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AMForm;
